import { Job } from './CRUDs/entities/Job';
import { Visit } from './CRUDs/entities/Visit';
import { Order } from './CRUDs/entities/Order';

export default {
    init() {
        this.initOpenWarningModal();
        this.initWarningModalPaginator();
        this.initWarningModalButtons();
        this.initOfficeActions();
    },

    initOpenWarningModal() {
        $('body').on('click keydown', '.model-warning-icon', function(e) {
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
            if (e.type === 'keydown') e.preventDefault();
            const $trigger = $(this);
            const workerOfficeAction = $trigger.hasClass('bb-worker-attention-marker');
            $.ajax({
                url: workerOfficeAction
                    ? '/warning-service/worker-office-action'
                    : '/warning-service/modal',
                method: 'get',
                dataType: 'html',
                data: {
                    id: $trigger.data('id'),
                    class: $trigger.data('class')
                },
                success(response) {
                    $('#form-container').html(response);
                    const modalSelector = workerOfficeAction
                        ? '#worker-office-action-modal'
                        : '#order-warning-modal';
                    $(modalSelector).modal('show');
                    if (workerOfficeAction) {
                        $trigger.addClass('is-seen')
                            .attr('data-opened', 'true')
                            .attr('title', 'Needs office action — opened');
                    }
                }
            });
        });
    },

    initWarningModalPaginator() {
        const service = this;
        $('body').on('click', '.left-paginator-button, .right-paginator-button', function() {
            const $modal = $('#order-warning-modal');
            const max = Number($modal.find('.warning-max-number').text());
            const current = Number($modal.find('.warning-current-number').text());
            const left = $(this).hasClass('left-paginator-button');
            if ((left && current === 1) || (!left && max === current)) return;
            const needed = left ? current - 1 : current + 1;
            $modal.find(`.warning-block[data-warning_number='${current}']`).addClass('d-none');
            $modal.find(`.warning-block[data-warning_number='${needed}']`).removeClass('d-none');
            $modal.find('.warning-current-number').text(needed);
            service.syncWarningModalAction($modal, needed);
        });
    },

    initWarningModalButtons() {
        const service = this;
        $('body').on('click', '.warning-close-button', () => $('#order-warning-modal').modal('hide'));
        $('body').on('click', '.warning-remove-button', function() { service.removeGenericWarning($(this)); });
    },

    initOfficeActions() {
        const service = this;
        $('body').on('click', '.warning-office-action', function() {
            const $button = $(this);
            const $actions = $button.closest('.warning-office-actions');
            const action = $button.data('office-action');
            const context = service.officeContext($actions);

            if (action === 'cancel') {
                $actions.find('.bb-choice-stack').addClass('d-none');
                $actions.find('.warning-cancel-confirmation').removeClass('d-none');
                $actions.find('.warning-cancel-comment').trigger('focus');
                return;
            }
            if (action === 'marked_addressed') {
                service.markAddressed($button, context);
                return;
            }

            $button.closest('.modal').modal('hide');
            if (action === 'reassign') {
                const entity = service.entity(context.entityType, context.modelId);
                if (entity && entity.openModal('assing_workers')) {
                    service.attachResolutionContext($(`#assing_workers-${entity.entityClass}`), context, 'reassigned');
                }
                return;
            }
            if (action === 'reschedule') {
                if (context.entityType === 'appointment') {
                    $('body').one('shown.bs.modal.workerWarning', '#reschedule-modal', function() {
                        service.attachResolutionContext($(this).find('form'), context, 'rescheduled');
                    });
                    window.getRescheduleModal(context.modelId);
                } else {
                    const entity = service.entity(context.entityType, context.modelId);
                    if (entity && entity.openModal('edit')) {
                        service.attachResolutionContext($(`#edit-${entity.entityClass}`), context, 'rescheduled');
                    }
                }
                return;
            }
            if (action === 'follow_up_visit') {
                const visit = new Visit();
                if (visit.openModal('create', { job_request_id: context.jobRequestId })) {
                    service.attachResolutionContext($('#create-visit'), context, 'follow_up_visit');
                }
            }
        });

        $('body').on('click', '.warning-cancel-back', function() {
            const $actions = $(this).closest('.warning-office-actions');
            $actions.find('.warning-cancel-confirmation').addClass('d-none');
            $actions.find('.bb-choice-stack').removeClass('d-none');
        });
        $('body').on('click', '.warning-cancel-confirm', function() {
            const $button = $(this);
            const $actions = $button.closest('.warning-office-actions');
            service.cancelRecord($button, service.officeContext($actions), $actions.find('.warning-cancel-comment').val());
        });
    },

    entity(type, id) {
        if (type === 'job') return new Job(id);
        if (type === 'visit') return new Visit(id);
        if (type === 'appointment') return new Order(id);
        return null;
    },

    officeContext($actions) {
        return {
            modelId: Number($actions.data('model-id')),
            modelClass: $actions.data('model-class'),
            entityType: $actions.data('entity-type'),
            jobRequestId: Number($actions.data('job-request-id')) || null,
        };
    },

    resolutionData(context, resolution, comment = '') {
        return {
            worker_warning_entity_type: context.entityType,
            worker_warning_entity_id: context.modelId,
            worker_warning_resolution: resolution,
            worker_warning_comment: comment,
        };
    },

    attachResolutionContext($form, context, resolution) {
        if (!$form.length) return;
        $form.find('input[data-worker-warning-context]').remove();
        Object.entries(this.resolutionData(context, resolution)).forEach(([name, value]) => {
            $('<input>', { type: 'hidden', name, value: value == null ? '' : value, 'data-worker-warning-context': 'true' }).appendTo($form);
        });
    },

    markAddressed($button, context) {
        const service = this;
        const $modal = $button.closest('.modal');
        const $feedback = $modal.find('.warning-action-feedback');
        $button.addClass('is-busy').prop('disabled', true);
        $.ajax({
            url: '/warning-service/remove', method: 'post',
            data: { warning_code: 'WUC1', model_id: context.modelId, model_class: context.modelClass, resolution_action: 'marked_addressed' },
            success() {
                $modal.modal('hide');
                service.removeWarningIcon(context.modelId, 'WUC1');
                service.refreshTable();
            },
            error() {
                $button.removeClass('is-busy').prop('disabled', false);
                $feedback.addClass('is-visible is-error').text('Could not mark this report addressed. Please try again.');
            }
        });
    },

    cancelRecord($button, context, comment) {
        const service = this;
        const $modal = $button.closest('.modal');
        const appointment = context.entityType === 'appointment';
        const url = appointment ? `/order/${context.modelId}/change-status` : `/jobs-flow/visit/${context.modelId}/cancel?modal_response=true`;
        const data = { ...service.resolutionData(context, 'canceled', comment), ...(appointment ? { status: 5 } : {}) };
        $button.addClass('is-loading').prop('disabled', true);
        $.ajax({
            url, method: 'post', data,
            success(response) {
                $modal.modal('hide');
                service.removeWarningIcon(context.modelId, 'WUC1');
                if (response && response.modal) {
                    $('#success-action-modal').remove();
                    $('#form-container').append(response.modal);
                    $('#success-action-modal').modal('show');
                }
                service.refreshTable();
            },
            error(xhr) {
                $button.removeClass('is-loading').prop('disabled', false);
                $modal.find('.warning-action-feedback').addClass('is-visible is-error')
                    .text((xhr.responseJSON && xhr.responseJSON.message) || 'Could not cancel this record. Please try again.');
            }
        });
    },

    removeGenericWarning($button) {
        const service = this;
        const $modal = $('#order-warning-modal');
        const $feedback = $modal.find('.warning-action-feedback');
        const code = $button.attr('data-warning_code');
        const id = $button.attr('data-model_id');
        const modelClass = $button.attr('data-model_class');
        const current = Number($modal.find('.warning-current-number').text()) || 1;
        const max = Number($modal.find('.warning-max-number').text()) || 1;
        $button.addClass('is-loading').prop('disabled', true);
        $.ajax({
            url: '/warning-service/remove', method: 'post',
            data: { warning_code: code, model_id: id, model_class: modelClass },
            success() {
                if (max > 1) {
                    $modal.find(`.warning-block[data-warning_number='${current}']`).remove();
                    $modal.find('.warning-block').first().removeClass('d-none');
                    $modal.find('.warning-current-number').text('1');
                    $modal.find('.warning-max-number').text(max - 1);
                    if (max - 1 === 1) $modal.find('.warning-paginator').remove();
                    service.resetWarningCounter($modal);
                    service.syncWarningModalAction($modal, 1);
                    $button.removeClass('is-loading').prop('disabled', false);
                } else $modal.modal('hide');
                service.removeWarningIcon(id, code);
            },
            error() {
                $button.removeClass('is-loading').prop('disabled', false);
                $feedback.addClass('is-visible is-error').text('Could not remove the warning. Please try again.');
            }
        });
    },

    syncWarningModalAction($modal, number) {
        const $warning = $modal.find(`.warning-block[data-warning_number='${number}']`);
        const code = $warning.attr('data-warning_code');
        const label = $warning.attr('data-warning_action_label') || '';
        $modal.find('.warning-remove-button').toggleClass('d-none', code === 'WUC1')
            .attr('data-warning_code', code || '').attr('data-default-label', label).text(label || 'Remove Warning');
        $modal.find('.warning-action-feedback').removeClass('is-visible is-error').empty();
    },

    removeWarningIcon(id, code) {
        const icons = $(`.data-view.d-block .model-warning-icon[data-id='${id}']`);
        const matching = icons.filter(`[data-warning-code='${code}']`);
        (matching.length ? matching : icons.last()).remove();
    },

    refreshTable() {
        if (typeof window.fetchTableData === 'function') window.fetchTableData();
    },

    resetWarningCounter($modal) {
        $modal.find('.warning-block').each(function(key) { $(this).attr('data-warning_number', key + 1); });
    }
};
